module.exports = (Modernizr.touch && !window._phantom)
